// TL PDP-Set (A/B) — sections/tl-0014-sh-set.liquid, docs/64
// Checkboxen -> Summe neu rechnen; Button -> alle angehakten Zeilen mit EINEM /cart/add.js
// (items[], erste Variante, Einmalkauf; Property _tl_set nur, wenn der Set-Rabatt gilt,
// immer Warenkorb-Attribut tl_set für die Auswertung), danach
// Cart-Drawer neu rendern (Geschenkstufen) und öffnen. Nutzt die Warteschlange des
// Upsell-Drawers (window._tlUpsellDrawerApi), damit sich Cart-Requests nicht überholen.
// ABlyft: tl-set-viewed (Set im Viewport), tl-set-added (custom), tl-set-value (revenue, Euro),
// dazu tl-set-added-full (alle verfügbaren Zeilen angehakt) bzw. tl-set-added-partial.
// Bestellung: Warenkorb-Attribute tl_set (Hauptprodukt-Handles, ":rabatt" im Rabatt-Fall) und
// tl_set_items (Produktnamen der Set-Adds, ", "-getrennt) -> recordSet(). docs/64 "Tracking".
// Set-Rabatt A/B: data-discount-mode "off" | "ab" | "always"; bei "ab" nur mit
// html.ab-set-discount (ABlyft setzt die Klasse ggf. erst nach dem Consent -> Observer).

(function () {
  'use strict';

  function track(event) {
    window.ablyft = window.ablyft || [];
    window.ablyft.push(event);
  }

  // Shopify-Geldformat (shop.money_format), damit die Summe aussieht wie die Liquid-Preise.
  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    function fmt(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return String(format || '{{amount_with_comma_separator}}€').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, '.', ','); // amount_with_comma_separator
      }
    });
  }

  function cartFetch(url, options) {
    var api = window._tlUpsellDrawerApi;
    if (api) return api.cartFetch(url, options);
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  function refreshAndOpenCart() {
    var api = window._tlUpsellDrawerApi;
    // NICHT api.updateCartCount: dessen cart:change ohne `sections` lässt Prestiges
    // CartDrawer.onCartChange werfen (siehe tl-upsell-modal.js).
    var refresh = api
      ? api.refreshCart()
      : (document.dispatchEvent(new CustomEvent('cart:refresh')), fetch('/cart.js').then(function (r) { return r.json(); }));
    return refresh.then(function (cart) {
      if (cart) document.querySelectorAll('cart-count').forEach(function (el) { el.itemCount = cart.item_count; });
      if (api) return api.openCartDrawer();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
      else window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
    });
  }

  // Warenkorb-Attribute für die Auswertung in den Bestellungen („Zusätzliche Details“, CSV „Note
  // Attributes“): tl_set = Liste der Hauptprodukt-Handles, tl_set_items = Namen aller übers Set
  // hinzugefügten Produkte (wie tl_upsell_items). Fehler dürfen den Kaufablauf nie stören.
  function recordSet(setKey, names) {
    return cartFetch('/cart.js')
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var keys = attrs.tl_set ? String(attrs.tl_set).split(',') : [];
        if (keys.indexOf(setKey) === -1) keys.push(setKey);
        var items = attrs.tl_set_items ? String(attrs.tl_set_items).split(', ') : [];
        names.forEach(function (name) { if (name) items.push(String(name).replace(/,/g, ' ')); });
        return cartFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { tl_set: keys.join(','), tl_set_items: items.join(', ') } })
        });
      })
      .catch(function (error) {
        console.warn('[PDP-Set] Warenkorb-Attribut nicht gesetzt:', error);
      });
  }

  var DISCOUNT_CLASS = 'ab-set-discount';

  function init(root) {
    if (root._tlSetReady) return;
    root._tlSetReady = true;

    var items = [].slice.call(root.querySelectorAll('[data-tl-set-item]'));
    var sumEl = root.querySelector('[data-tl-set-sum]');
    var compareEl = root.querySelector('[data-tl-set-compare]');
    var cta = root.querySelector('[data-tl-set-cta]');
    var errorEl = root.querySelector('[data-tl-set-error]');
    var format = root.dataset.moneyFormat;

    function selected() {
      return items.filter(function (item) {
        var input = item.querySelector('[data-tl-set-check]');
        return input && input.checked && !input.disabled;
      });
    }

    function showError(show) {
      if (!errorEl) return;
      errorEl.textContent = show ? (root.dataset.errorText || '') : '';
      errorEl.hidden = !show;
    }

    // Set-Preis gilt wie in der Discount Function nur bei Hauptprodukt + mind. einem Zusatzprodukt.
    var main = items.filter(function (item) { return item.hasAttribute('data-main'); })[0];
    var hasDiscount = root.hasAttribute('data-set-discount');
    var discountMode = root.dataset.discountMode || 'off';

    // Gilt der Set-Rabatt in diesem Arm?
    function discountOn() {
      return hasDiscount && (discountMode === 'always' ||
        (discountMode === 'ab' && document.documentElement.classList.contains(DISCOUNT_CLASS)));
    }

    var mode = root.dataset.setMode || '';
    var required = Number(root.dataset.setRequired) || 0;
    // "zusatzprodukte_komplett" / "alle_set_zeilen_komplett": Rabatt nur bei komplettem Set
    var complete = /_komplett$/.test(mode);

    // Erfüllt die Auswahl die Set-Regel der Discount Function? Hauptprodukt + mindestens ein
    // Zusatzprodukt; bei "…_komplett" alle verfügbaren Zusatzprodukte.
    function qualifies() {
      if (!main) return false;
      var sel = selected();
      if (sel.indexOf(main) === -1) return false;
      var addons = sel.length - 1;
      if (complete) return required > 0 && addons >= required;
      return addons >= 1;
    }

    // Set-Preis anzeigen (nur wenn die Section den Rabatt anzeigen soll)
    function setActive() {
      return discountOn() && qualifies();
    }

    function linePrice(item, active) {
      return Number(active && item.dataset.setPrice ? item.dataset.setPrice : item.dataset.price) || 0;
    }

    function update() {
      var sum = 0;
      var compare = 0;
      var sel = selected();
      var active = setActive();
      root.classList.toggle('is-set-active', active);
      sel.forEach(function (item) {
        sum += linePrice(item, active);
        compare += Number(item.dataset.compare) || 0;
      });
      sumEl.textContent = formatMoney(sum, format);
      var onSale = compare > sum;
      sumEl.classList.toggle('is-sale', onSale);
      compareEl.textContent = formatMoney(compare, format);
      compareEl.hidden = !onSale;
      cta.disabled = sel.length === 0;
    }

    function add() {
      var sel = selected();
      if (!sel.length || cta.classList.contains('is-loading')) return;
      cta.classList.add('is-loading');
      cta.disabled = true;
      showError(false);

      var setKey = root.dataset.setKey;
      var discounted = discountOn();
      var markValue = discounted && root.hasAttribute('data-set-mark') && qualifies()
        ? (complete ? setKey + ':' + required : setKey)
        : '';
      var value = 0;
      var active = setActive();
      // Komplett = alle verfügbaren (nicht ausverkauften) Zeilen angehakt
      var full = sel.length === items.filter(function (item) {
        var input = item.querySelector('[data-tl-set-check]');
        return input && !input.disabled;
      }).length;
      var names = sel.map(function (item) { return item.dataset.title; });
      var body = JSON.stringify({
        items: sel.map(function (item) {
          value += linePrice(item, active);
          var line = { id: Number(item.dataset.variantId), quantity: 1 };
          // Markierung nur bei aktivem Set-Rabatt UND erfüllter Set-Regel (Properties trennen
          // Warenkorbzeilen). "komplett" trägt die Anzahl verfügbarer Zusatzprodukte mit.
          if (markValue) line.properties = { _tl_set: markValue };
          return line;
        })
      });

      cartFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
        .then(function () {
          track({ eventType: 'custom', eventName: 'tl-set-added' });
          track({ eventType: 'custom', eventName: full ? 'tl-set-added-full' : 'tl-set-added-partial' });
          track({ eventType: 'revenue', eventName: 'tl-set-value', eventValue: value / 100 });
          return recordSet(markValue ? setKey + ':rabatt' : setKey, names).then(refreshAndOpenCart);
        })
        .catch(function (error) {
          console.error('[PDP-Set] Hinzufügen fehlgeschlagen:', error);
          showError(true);
        })
        .then(function () {
          cta.classList.remove('is-loading');
          update();
        });
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-tl-set-check]')) {
        showError(false);
        update();
      }
    });
    cta.addEventListener('click', add);

    // tl-set-viewed: nur wenn das Set wirklich sichtbar ist (Testarm / "Immer zeigen").
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && root.offsetParent !== null) {
            track({ eventType: 'custom', eventName: 'tl-set-viewed' });
            observer.disconnect();
          }
        });
      }, { threshold: 0.4 });
      observer.observe(root.querySelector('.tl-set__card') || root);
    }

    // Rabatt-Arm kann nach dem Laden kommen (ABlyft nach Consent) -> Anzeige nachziehen
    if (discountMode === 'ab' && hasDiscount && 'MutationObserver' in window) {
      new MutationObserver(update).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-tl-set]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', initAll);
})();
